import http from '../../../../../libs/http'

const api = `${process.env.VUE_APP_MICROSERVICE_API_AMORTIZATIONS}/products-accounts/product`

export default ({ productId }) => http.get(`${api}/${productId}`)
